const EMPLOYEES_FETCH_FAILURE = 'EMPLOYEES_FETCH_FAILURE';
const EMPLOYEES_FETCH_REQUEST = 'EMPLOYEES_FETCH_REQUEST';
const EMPLOYEES_FETCH_SUCCESS = 'EMPLOYEES_FETCH_SUCCESS';

export {
  EMPLOYEES_FETCH_FAILURE,
  EMPLOYEES_FETCH_REQUEST,
  EMPLOYEES_FETCH_SUCCESS,
}